import { Lightning, Shield, Lightbulb, MapPin } from '@/icons';
import { SectionHeading } from '@/components/ui/SectionHeading';

const points = [
  {
    icon: MapPin,
    title: 'Cyprus-based',
    body: 'Registered in Larnaca, working EU hours, visible enough to be met in person when you want it.',
  },
  {
    icon: Lightbulb,
    title: 'No templates',
    body: 'Every project starts from your content and your audience. We reuse patterns we have tested - never themes.',
  },
  {
    icon: Shield,
    title: 'Own your work',
    body: 'Final payment transfers full rights and source files. If you want to leave us, the repo is yours and readable.',
  },
  {
    icon: Lightning,
    title: 'Ship fast',
    body: 'Logo in two to three weeks. Five-page site in four to six. We keep the pace because you have a business to run.',
  },
];

export function WhyUs() {
  return (
    <section className="px-6 md:px-12 lg:px-20 py-24 md:py-32">
      <div className="mx-auto max-w-[1440px] flex flex-col gap-14">
        <SectionHeading
          eyebrow="Why us"
          title={<>Four reasons, all of them plain.</>}
        />
        <div className="grid md:grid-cols-2 gap-8 md:gap-12">
          {points.map(({ icon: Icon, title, body }) => (
            <div key={title} className="flex gap-6">
              <Icon className="w-8 h-8 text-accent shrink-0 mt-1" />
              <div className="flex flex-col gap-2">
                <h3 className="font-display text-2xl font-medium">{title}</h3>
                <p className="text-ink-secondary leading-relaxed max-w-md">{body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
